import React from 'react';
import { CTAButton } from './CTAButton';
import { PRICE, PRODUCT_NAME } from './salesData';
import { AUDIENCE_IMAGE_URL } from '../utils/headMeta';
export function FinalCta() {
  return <section className="bg-white pb-8 pt-12 sm:pb-10 sm:pt-16" data-id="element-67" data-mp="19epctsvez6y2">
      <div className="mx-auto max-w-4xl px-5" data-id="element-68" data-mp="19cun81976qnn">
        <div className="overflow-hidden rounded-[2rem] bg-cream" data-id="element-69" data-mp="15d41wd2fx2qi">
          <img src={AUDIENCE_IMAGE_URL} alt="Mujer sirviendo un plato de pollo con palta y ensalada en una cocina luminosa" loading="lazy" decoding="async" width={1200} height={800} className="h-[190px] w-full object-cover sm:h-[280px]" data-id="element-70" data-mp="15fq5k1m7my3g" />

          <div className="px-6 pb-7 pt-8 text-center sm:px-10 sm:py-10" data-id="element-71" data-mp="1o3lhdfy9i1tx">
            <h2 className="mx-auto max-w-[22ch] font-display text-[1.55rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:max-w-[30ch] sm:text-[2.2rem]" data-id="element-72" data-mp="223mj0xmcpdag">
              Mañana ya no tienes que pensar qué cocinar.{' '}
              <span className="mark-yellow" data-id="element-73" data-mp="n6nsn2tp2cyw">Solo elegir.</span>
            </h2>

            <p className="mx-auto mt-3.5 max-w-[44ch] font-sans text-[0.9rem] leading-relaxed text-taupe sm:text-[0.98rem]" data-id="element-74" data-mp="s45uk99anrxe">
              Más de 500 recetas Keto y Sin Gluten, listas para abrir desde el celular mientras
              cocinas.
            </p>

            <p className="mt-6 font-display text-[1.1rem] font-extrabold uppercase leading-tight tracking-tight text-charcoal" data-id="element-75" data-mp="120sdgsi288ws">
              {PRODUCT_NAME}
            </p>
            <p className="mt-2 font-sans text-[0.95rem] font-semibold text-charcoal" data-id="element-76" data-mp="1b1ywp9c3fxtq">
              <span className="mr-2 font-medium text-taupe" style={{
              textDecoration: 'line-through'
            }} data-id="element-77" data-mp="1fvbbysuvus9t">
                {PRICE.previous}
              </span>
              <span className="font-display text-[1.35rem] font-extrabold tracking-tight text-charcoal" data-id="element-78" data-mp="1psfu8hlly3lc">
                Hoy {PRICE.current}
              </span>{' '}
              · pago único
            </p>

            <div className="mt-5 flex justify-center" data-id="element-79" data-mp="3qufdtpskrks5">
              <CTAButton className="w-full max-w-[26rem] px-4" data-id="element-80" data-mp="3qux8ihzl9qxy" />
            </div>

            <p className="mt-3 font-sans text-[0.74rem] font-medium text-taupe" data-id="element-81" data-mp="3lx5ijtii8ewe">
              Acceso digital inmediato · Pago seguro
            </p>
          </div>
        </div>
      </div>
    </section>;
}